import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-trend-text',
  templateUrl: './trend-text.component.html',
  styleUrls: ['./trend-text.component.scss']
})
export class TrendTextComponent implements OnInit {
  @Input() trendScore = 0;
  @Input() textSize = '16px';
  @Input() fontSize = '16px';
  @Input() isUnknownTrendValue : boolean = false;

  positiveTrendIconName = "trending_up";
  negativeTrendIconName = "trending_down";
  stableTrendIconName = "trending_flat";
  noTrendDataIconName = "question_mark";

  color = '#000000';
  iconName = '';
  trendPresentationScore = 0;
  constructor() { }

  ngOnInit(): void {
    this.setColor();
    this.setIcon();
    this.setScore();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.trendScore != undefined &&
        changes.trendScore.currentValue != changes.trendScore.previousValue &&
        changes.trendScore.firstChange){
          this.setColor();
          this.setIcon();
          this.setScore();
        }
  }

  setColor() : void{
    if (this.trendScore > 0){
      this.color = '#229A16';
    }
    else if (this.trendScore < 0){
      this.color = '#B72136';
    }
    else{
      this.color = '#000000';
    }
  }

  setIcon() : void{
    // For now we are presenting not updated data after user's approval
    // if (this.isUnknownTrendValue){
    //   this.iconName = this.noTrendDataIconName;
    // }
    if (this.trendScore == 0){
      this.iconName = this.stableTrendIconName;
    }
    else if (this.trendScore > 0){
      this.iconName = this.positiveTrendIconName;
    }
    else{ // trendValue < 0
      this.iconName = this.negativeTrendIconName;
    }
  }

  setScore() : void{
    this.trendPresentationScore = Math.abs(this.trendScore);
  }

}
